module.exports = {
  entry: './src/apps/csp-carrier-interactive-tour/index.tsx',
  shortcode: 'csp-carrier-interactive-tour',
  title: 'CSP Carrier - Interactive Tour',
  status: 'stable',
  description: 'CSP Carrier - Interactive Tour Widget',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-csp-carrier-interactive-tour--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/products'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
